import type { FireAnalyticsEvent } from '../../types';
import type {
	PreloadQueryVarsDiff,
	PreloadQueryVarsDiffReport,
} from '../../types/preload-query-vars-diff';

type PreloadQueryVarsDiffEventPayload = PreloadQueryVarsDiffReport & {
	search: PreloadQueryVarsDiff;
	rightPanel: PreloadQueryVarsDiff;
};

export const onPreloadQueryVarsDiff = ({
	match,
	mismatchCount,
	search,
	rightPanel,
}: PreloadQueryVarsDiffEventPayload): FireAnalyticsEvent => ({
	eventType: 'track',
	action: 'preloadQueryVarsDiff',
	actionSubject: 'searchPage',
	attributes: {
		additionalAttributes: {
			experienceName: 'search-page',
			match,
			mismatchCount,
			search,
			rightPanel,
		},
	},
});
